export const RECEIVE_MINI_WISHLIST = 'RECEIVE_MINI_WISHLIST';
export const MINI_WISHLIST_IS_FETCHING = 'MINI_WISHLIST_IS_FETCHING';

export const MINI_WISHLIST_ROOT_ELEMENT = document.getElementById('mini-wishlist');
export const TRANSFER_MINI_WISHLIST_ADD = 'TRANSFER_MINI_WISHLIST_ADD';
export const TRANSFER_MINI_WISHLIST_REMOVE = 'TRANSFER_MINI_WISHLIST_REMOVE';
